module.exports = require("standard-error");;